import axios from 'axios'
import { serializeParams } from '../utils/genericUtils'

export default {
  namespaced: true,

  actions: {
    createRoute(_, data) {
      return axios({
        url: `${process.env.VUE_APP_URL}/transport/route`,
        method: 'POST',
        data,
      })
    },
    cloneRoute(_, idRoute) {
      return axios({
        url: `${process.env.VUE_APP_URL}/transport/route/${idRoute}/clone`,
        method: 'POST',
      })
    },
    editRoute(_, { idRoute, data }) {
      return axios({
        url: `${process.env.VUE_APP_URL}/transport/route/${idRoute}`,
        method: 'PUT',
        data,
      })
    },
    addCollabToRoute(_, { idRoute, data }) {
      return axios({
        url: `${process.env.VUE_APP_URL}/transport/route/${idRoute}/assignDriver`,
        method: 'PUT',
        data,
      })
    },
    getRoutes(_, params) {
      return axios({
        url: `${process.env.VUE_APP_URL}/transport/route`,
        method: 'GET',
        params,
      })
    },
    getRoute(_, idRoute) {
      return axios({
        url: `${process.env.VUE_APP_URL}/transport/route/${idRoute}`,
        method: 'GET',
      })
    },
    getRouteDetails(_, { idRoute, params }) {
      return axios({
        url: `${
          process.env.VUE_APP_URL
        }/transport/route/${idRoute}/students${serializeParams(params)}`,
        method: 'GET',
      })
    },
    getRouteStudents(_, params) {
      return axios({
        url: `${
          process.env.VUE_APP_URL
        }/transport/delivery/students${serializeParams(params)}`,
        method: 'GET',
      })
    },
    getRouteStudentsReportFilters(_) {
      return axios({
        url: `${process.env.VUE_APP_URL}/transport/delivery/students/filters`,
        method: 'GET',
      })
    },
    removeDriverRoute(_, idRoute) {
      return axios({
        url: `${process.env.VUE_APP_URL}/transport/route/${idRoute}/removeDriver`,
        method: 'PUT',
      })
    },
    removeRoute(_, idRoute) {
      return axios({
        url: `${process.env.VUE_APP_URL}/transport/route/${idRoute}`,
        method: 'DELETE',
      })
    },
    getXlsx(_, params) {
      return axios({
        headers: {
          Accept: 'application/octet-stream',
          'Content-Type': 'application/octet-stream',
        },
        url: `${
          process.env.VUE_APP_URL
        }/transport/delivery/students/xlsx${serializeParams(params)}`,
        method: 'GET',
        responseType: 'blob',
      })
    },
    getPdf(_, params) {
      return axios({
        headers: {
          Accept: 'application/octet-stream',
          'Content-Type': 'application/octet-stream',
        },
        url: `${
          process.env.VUE_APP_URL
        }/transport/delivery/students/pdf${serializeParams(params)}`,
        method: 'GET',
        responseType: 'blob',
      })
    },
  },
}
